export const umbrellaButtonPositions = [
  { id: 1, x: 6300, y: 5510, type: "station", tooltip: "Bordo vasca" },
  { id: 2, x: 6080, y: 5760, type: "station", tooltip: "Bordo vasca" },
  { id: 3, x: 5820, y: 5960, type: "station", tooltip: "Bordo vasca" },
  { id: 4, x: 5550, y: 6150, type: "station", tooltip: "Bordo vasca" },
  { id: 5, x: 5280, y: 6350, type: "station", tooltip: "Bordo vasca" },
  { id: 6, x: 4980, y: 6500, type: "station", tooltip: "Bordo vasca" },
  { id: 7, x: 4680, y: 6650, type: "station", tooltip: "Bordo vasca" },
  { id: 8, x: 4350, y: 6760, type: "station", tooltip: "Bordo vasca" },
  { id: 9, x: 4020, y: 6850, type: "station", tooltip: "Bordo vasca" },
  { id: 10, x: 3680, y: 6920, type: "station", tooltip: "Bordo vasca" },
  { id: 11, x: 3330, y: 6920, type: "station", tooltip: "Bordo vasca" },
  { id: 12, x: 2980, y: 6870, type: "station", tooltip: "Bordo vasca" },
  { id: 13, x: 2640, y: 6780, type: "station", tooltip: "Bordo vasca" },
  { id: 14, x: 2320, y: 6650, type: "station", tooltip: "Bordo vasca" },
  { id: 15, x: 2020, y: 6480, type: "station", tooltip: "Bordo vasca" },
  { id: 16, x: 1740, y: 6260, type: "station", tooltip: "Bordo vasca" },
  { id: 17, x: 1520, y: 5980, type: "station", tooltip: "Bordo vasca" },
  { id: 18, x: 1350, y: 5680, type: "station", tooltip: "Bordo vasca" },

  // start top row
  { id: 19, x: 470, y: 4150, type: "umbrella", tooltip: "" },
  { id: 20, x: 470, y: 3860, type: "umbrella", tooltip: "" },
  { id: 21, x: 480, y: 3570, type: "umbrella", tooltip: "" },
  { id: 22, x: 500, y: 3290, type: "umbrella", tooltip: "" },
  { id: 23, x: 550, y: 3010, type: "umbrella", tooltip: "" },
  { id: 24, x: 610, y: 2730, type: "umbrella", tooltip: "" },
  { id: 25, x: 680, y: 2450, type: "umbrella", tooltip: "" },
  { id: 26, x: 780, y: 2180, type: "umbrella", tooltip: "" },
  { id: 27, x: 900, y: 1920, type: "umbrella", tooltip: "" },
  { id: 28, x: 1030, y: 1670, type: "umbrella", tooltip: "" },
  { id: 29, x: 1190, y: 1440, type: "umbrella", tooltip: "" },
  { id: 30, x: 1370, y: 1220, type: "umbrella", tooltip: "" },
  { id: 31, x: 1580, y: 1030, type: "umbrella", tooltip: "" },
  { id: 32, x: 1800, y: 860, type: "umbrella", tooltip: "" },
  { id: 33, x: 2060, y: 740, type: "umbrella", tooltip: "" },
  { id: 34, x: 2330, y: 640, type: "umbrella", tooltip: "" },
  { id: 35, x: 2610, y: 570, type: "umbrella", tooltip: "" },
  { id: 36, x: 2900, y: 540, type: "umbrella", tooltip: "" },
  { id: 37, x: 3200, y: 530, type: "umbrella", tooltip: "" },
  { id: 38, x: 3500, y: 520, type: "umbrella", tooltip: "" },
  { id: 39, x: 3800, y: 530, type: "umbrella", tooltip: "" },
  { id: 40, x: 4100, y: 550, type: "umbrella", tooltip: "" },
  { id: 41, x: 4430, y: 490, type: "umbrella", tooltip: "" },
  { id: 42, x: 4780, y: 430, type: "umbrella", tooltip: "" },
  { id: 43, x: 5150, y: 400, type: "umbrella", tooltip: "" },
  { id: 44, x: 5510, y: 400, type: "umbrella", tooltip: "" },
  { id: 45, x: 5900, y: 430, type: "umbrella", tooltip: "" },
  { id: 46, x: 6280, y: 540, type: "umbrella", tooltip: "" },
  { id: 47, x: 6590, y: 800, type: "umbrella", tooltip: "" },
  { id: 48, x: 6840, y: 1100, type: "umbrella", tooltip: "" },
  { id: 49, x: 7050, y: 1400, type: "umbrella", tooltip: "" },
  { id: 50, x: 7200, y: 1800, type: "umbrella", tooltip: "" },
  // end top row

  // start 2nd row
  { id: 51, x: 5000, y: 800, type: "umbrella", tooltip: "" },
  { id: 52, x: 5350, y: 880, type: "umbrella", tooltip: "" },
  { id: 53, x: 5700, y: 980, type: "umbrella", tooltip: "" },
  { id: 54, x: 6030, y: 1150, type: "umbrella", tooltip: "" },
  { id: 55, x: 6330, y: 1350, type: "umbrella", tooltip: "" },
  { id: 56, x: 6630, y: 1580, type: "umbrella", tooltip: "" },
  // end 2nd row

  // start 3rd row
  { id: 57, x: 4500, y: 1200, type: "umbrella", tooltip: "" },
  { id: 58, x: 4850, y: 1320, type: "umbrella", tooltip: "" },
  { id: 59, x: 5180, y: 1470, type: "umbrella", tooltip: "" },
  { id: 60, x: 5520, y: 1620, type: "umbrella", tooltip: "" },
  { id: 61, x: 5840, y: 1770, type: "umbrella", tooltip: "" },
  { id: 62, x: 6160, y: 1950, type: "umbrella", tooltip: "" },
  { id: 63, x: 6470, y: 2160, type: "umbrella", tooltip: "" },
  { id: 64, x: 6760, y: 2380, type: "umbrella", tooltip: "" },
  // end 3rd row

  // start 4th row
  { id: 65, x: 810, y: 5430, type: "umbrella", tooltip: "" },
  { id: 66, x: 850, y: 5150, type: "umbrella", tooltip: "" },
  { id: 67, x: 950, y: 4890, type: "umbrella", tooltip: "" },
  { id: 68, x: 1100, y: 4650, type: "umbrella", totooltip: "" },
  { id: 69, x: 1260, y: 4420, type: "umbrella", tooltip: "" },
  { id: 70, x: 1440, y: 4200, type: "umbrella", tooltip: "" },
  { id: 71, x: 1600, y: 3970, type: "umbrella", tooltip: "" },
  { id: 72, x: 1740, y: 3720, type: "umbrella", tooltip: "" },
  { id: 73, x: 1850, y: 3450, type: "umbrella", tooltip: "" },
  { id: 74, x: 1890, y: 3170, type: "umbrella", tooltip: "" },
  { id: 75, x: 1880, y: 2890, type: "umbrella", tooltip: "" },
  { id: 76, x: 1890, y: 2600, type: "umbrella", tooltip: "" },
  { id: 77, x: 1960, y: 2310, type: "umbrella", tooltip: "" },
  { id: 78, x: 2140, y: 2070, type: "umbrella", tooltip: "" },
  { id: 79, x: 2370, y: 1890, type: "umbrella", tooltip: "" },
  { id: 80, x: 2630, y: 1750, type: "umbrella", tooltip: "" },
  { id: 81, x: 2910, y: 1650, type: "umbrella", tooltip: "" },
  { id: 82, x: 3200, y: 1610, type: "umbrella", tooltip: "" },
  { id: 83, x: 3490, y: 1610, type: "umbrella", tooltip: "" },
  { id: 84, x: 3780, y: 1660, type: "umbrella", tooltip: "" },
  { id: 85, x: 4200, y: 1780, type: "umbrella", tooltip: "" },
  { id: 86, x: 4460, y: 1870, type: "umbrella", tooltip: "" },
  { id: 87, x: 4720, y: 1970, type: "umbrella", tooltip: "" },
  { id: 88, x: 4970, y: 2080, type: "umbrella", tooltip: "" },
  { id: 89, x: 5220, y: 2200, type: "umbrella", tooltip: "" },
  { id: 90, x: 5470, y: 2330, type: "umbrella", tooltip: "" },
  { id: 91, x: 5720, y: 2460, type: "umbrella", tooltip: "" },
  { id: 92, x: 5960, y: 2600, type: "umbrella", tooltip: "" },
  { id: 93, x: 6200, y: 2740, type: "umbrella", tooltip: "" },
  { id: 94, x: 6460, y: 2880, type: "umbrella", tooltip: "" },
  // { id: 95, x: 6460, y: 2930, type: 'umbrella' },
  // { id: 96, x: 6460, y: 2930, type: 'umbrella' },
];
